import { render, staticRenderFns } from "./job-description.vue?vue&type=template&id=4f60e6c4&scoped=true"
import script from "./job-description.vue?vue&type=script&lang=js"
export * from "./job-description.vue?vue&type=script&lang=js"
import style0 from "./job-description.vue?vue&type=style&index=0&id=4f60e6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60e6c4",
  null
  
)

export default component.exports